module.exports = __webpack_public_path__ + "files/ad3ed9d3cf247f4255eb95809a07a2f9.png";